// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__d+RN4","description":"styles_description__wJESm","timer":"styles_timer__VRxaT","actions":"styles_actions__CXwZ9"};